import { createAction } from "redux-actions";
import { CATEGORY_DETAILS_LOADED, CATEGORY_LOADED } from "../constants";
import logger from "../../../../lib/logger";
import { getCategoryDetails, getCategory } from "../../../../lib/api/category";
import { isSeoFriendly } from "../helpers";
import { AllHtmlEntities } from "html-entities";

export function loadCategoryDetails({
  country,
  language,
  query,
  uuid,
  xSiteOrigin
}) {
  return dispatch =>
    getCategoryDetails({
      country,
      language,
      query,
      uuid,
      xSiteOrigin
    })
      .then(response => dispatch(categoryDetailsLoaded(response)))
      .catch(async error => {
        error.message = `getCategoryDetails failed, and caught error: ${error.message} `;
        logger.error(error);
        await dispatch(categoryDetailsLoaded(error));

        throw error;
      });
}

export function loadCategory({ country, language, query, uuid, xSiteOrigin }) {
  return dispatch =>
    getCategory({
      country,
      language,
      query,
      uuid,
      xSiteOrigin
    })
      .then(response => dispatch(categoryLoaded(response)))
      .catch(async error => {
        error.message = `getCategory failed, and caught error: ${error.message}`;
        logger.error(error);

        await dispatch(categoryLoaded(error));

        throw error;
      });
}

export const decodeHtml = headerHtmlEncoded => {
  if (!isSeoFriendly(headerHtmlEncoded, true)) {
    return headerHtmlEncoded;
  } else {
    return AllHtmlEntities.decode(headerHtmlEncoded);
  }
};

export const categoryDetailsLoaded = createAction(
  CATEGORY_DETAILS_LOADED,
  response => ({
    ...response.categoryDetails,
    headerHtmlEncoded: decodeHtml(response.categoryDetails.headerHtmlEncoded)
  })
);

export const categoryLoaded = createAction(CATEGORY_LOADED, response => ({
  ...(SERVER
    ? {
        gender: require("../../../../server/render/common/breadcrumb").getGenderFromBreadcrumb(
          response.categories.breadcrumb
        )
      }
    : {}),
  ...response.categories
}));
